module.exports = __webpack_public_path__ + "03_long_brown.bc306ff5.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/papa/layer5/03_long_brown.png
// module id = iHuH
// module chunks = 0